export const useGetRequestUrl = () => {
  // const REQUEST_URL = `http://localhost:3001`;
  const REQUEST_URL = `https://rasoipe-backend.onrender.com`;
  return REQUEST_URL;
};
